import React from 'react';
import { Oferta } from './pages/Oferta';
type AppProps = {
  mostrarTestimonios?: boolean;
};
export function App({
  mostrarTestimonios = true
}: AppProps) {
  return <Oferta mostrarTestimonios={mostrarTestimonios} data-id="element-0" data-mp="35eodsnzhvziq" />;
}